import { FetchStoreInfoParams, StoreInfoApiResponseModel } from '../models/vendor-checkIn-model';

import { BaseService } from '../config/request';

export async function fetchStoreInfoData(params: FetchStoreInfoParams): Promise<StoreInfoApiResponseModel> {
  return (await BaseService.getAsync(`vendorpurposes`, params)) as StoreInfoApiResponseModel;
  // return (await BaseService.getAsync(`http://localhost:3001/vendorpurposes`, params)) as StoreInfoApiResponseModel;
}
